import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { Image } from "../Image/index.js";
import { PlainA } from "../PlainA/index.js";
import { Span } from "../Text/index.js";
import { getAttributeFlags, getIconSize } from "./Attribute.utils.js";
import { attributeVariants } from "./Attribute.variants.js";
const AttributeMedia = ({ altText, horizontalImageSize, iconClassName, iconName, iconSize, imageClassName, imageUrl, isVertical, showImage, text, wrapperClassName })=>/*#__PURE__*/ jsxs("div", {
        className: wrapperClassName,
        children: [
            showImage ? /*#__PURE__*/ jsx(Image, {
                src: imageUrl,
                alt: altText,
                borderRadius: isVertical ? 'md' : 'sm',
                width: 'auto',
                height: isVertical ? 'full' : horizontalImageSize,
                className: imageClassName
            }) : null,
            iconName ? /*#__PURE__*/ jsx(CdnIcon, {
                iconName: iconName,
                size: iconSize,
                className: iconClassName,
                title: text
            }) : null
        ]
    });
const AttributeActionLink = ({ actionIconName, actionIconText, emphasis, fontSize, isActionable })=>{
    if (!isActionable || !(actionIconName || actionIconText)) return null;
    return /*#__PURE__*/ jsx(PlainA, {
        iconLeft: actionIconName,
        textStyle: fontSize,
        emphasis: emphasis,
        variant: 'bold' === emphasis ? 'inline' : 'standalone',
        children: actionIconText
    });
};
const Attribute_Attribute = /*#__PURE__*/ forwardRef(function({ actionIconName, actionIconText, altText, className, emphasis = 'regular', href, iconName, imageUrl, isVertical, size, text, truncate, onClick, slots = {
    root: '',
    imageIconWrapperSlot: '',
    iconSlot: '',
    imageSlot: '',
    textSlot: ''
}, ...rest }, ref) {
    const { isActionable, showImage } = getAttributeFlags({
        altText,
        href,
        iconName,
        imageUrl,
        isVertical,
        onClick
    });
    const { imageIconWrapperSlot, iconSlot, imageSlot, root, textSlot, textWrapperSlot } = attributeVariants({
        emphasis,
        hasIcon: Boolean(iconName),
        isActionable,
        isVertical,
        showImage,
        size,
        truncate
    });
    const isSmall = 'sm' === size;
    const rootClasses = cn(root(), className ?? slots.root);
    const imageIconWrapperSlotClasses = cn(imageIconWrapperSlot(), slots.imageIconWrapperSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const imageSlotClasses = cn(imageSlot(), slots.imageSlot);
    const textSlotClasses = cn(textSlot(), slots.textSlot);
    const textWrapperSlotClasses = cn(textWrapperSlot(), slots.textWrapperSlot);
    const iconSize = getIconSize({
        isSmall,
        isVertical,
        showImage
    });
    const horizontalImageSize = isSmall ? 4 : 5;
    const fontSize = isSmall ? 'body3' : 'body2';
    const actionType = href ? 'a' : 'button';
    const Component = isActionable ? actionType : 'div';
    return /*#__PURE__*/ jsxs(Component, {
        ref: ref,
        className: rootClasses,
        onClick: onClick,
        href: href,
        ...rest,
        children: [
            /*#__PURE__*/ jsx(AttributeMedia, {
                altText: altText,
                horizontalImageSize: horizontalImageSize,
                iconClassName: iconSlotClasses,
                iconName: iconName,
                iconSize: iconSize,
                imageClassName: imageSlotClasses,
                imageUrl: imageUrl,
                isVertical: isVertical,
                showImage: showImage,
                text: text,
                wrapperClassName: imageIconWrapperSlotClasses
            }),
            /*#__PURE__*/ jsxs("div", {
                className: textWrapperSlotClasses,
                children: [
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: fontSize,
                        className: textSlotClasses,
                        children: text
                    }),
                    /*#__PURE__*/ jsx(AttributeActionLink, {
                        actionIconName: actionIconName,
                        actionIconText: actionIconText,
                        emphasis: emphasis,
                        fontSize: fontSize,
                        isActionable: isActionable
                    })
                ]
            })
        ]
    });
});
export { Attribute_Attribute as Attribute };
